module.exports = __webpack_public_path__ + "static/media/uz.bd8a19df.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/uz.svg
// module id = 2239
// module chunks = 0